import CreationWordDocument from "./CreationWordDocument";

export default CreationWordDocument;
